import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'

declare interface RouteInfo {
  text: string
  text2: string
  text3: string
}
export const MissionAndVisioContent: RouteInfo[] = [
  {
    text:
      'The California Hispanic Chambers of Commerce and its 120 Hispanic and diverse chambers and business association members represent the interest of over 850,000 Hispanic-owned businesses and bring the issues and needs impacting all Hispanic and diverse small companies and communities to the forefront of California and National economic agendas.',
    text2:
      "The California Hispanic Chambers of Commerce (CHCC) focuses its proactive education, advocacy, and empowerment efforts on programs and policies that answer and meet the needs and priorities of California's small businesses, diverse and Hispanic communities.",
    text3:
      "For over forty years, the CHCC has been the leading voice for Hispanic and diverse business owners in California. From its inception, the CHCC has been committed to fostering economic growth that creates and sustains prosperity for the benefit of California's economy and our communities.",
  },
]
@Component({
    selector: 'app-mission-and-vision',
    templateUrl: './mission-and-vision.component.html',
    styleUrls: ['./mission-and-vision.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MissionAndVisionComponent implements OnInit {
  mainTitle = 'Mission and Vision Statement '
  texts: any = []
  constructor() {}

  ngOnInit(): void {
    this.texts = MissionAndVisioContent.filter((text) => text)
  }
}
